interface DataLabel {
    align: string
    // x: number
    crop: boolean
    overflow: string
    useHTML: boolean
    formatter: () => string
}

interface DataPoint {
    x: number
    x2: number
    color: string
}

interface BaseSeriesObj {
    dataLabels: DataLabel[]
    pointWidth: number
    data: DataPoint[]
}

function createBaseSeriesObj(width: number): BaseSeriesObj {
    return {
        dataLabels: [
            {
                align: 'right',
                // x: width,
                crop: false,
                overflow: 'allow',
                useHTML: true,
                formatter: function () {
                    return renderRightLabel(this.point)
                }
            }
        ],
        pointWidth: 34,
        data: [
            {
                x: 0,
                x2: 100,
                color: '#DEE4E8'
            }
        ]
    }
}

export const renderPointForm = point => {
    return `
        <div style="background: none; border: none">
            <span style="font-size: 13px;"> ${point.custom.legendTitle} </span>  <br/>
            <b style="font-size: 13px">${point.custom.label}&nbsp</b> 
            <p style="font-size: 13px">(${point.custom.amount}%)</p><br/>   

        </div>
    `
}

export const renderRightLabel = point => {
    return `<div style="color: var(--gray-1000); font-size:14px; font-family: SourceSansPro-Semibold; background: rgba(255,255,255,0.8); border-radius: 3px; padding: 2px"><span>${point.custom.label} <span style="font-family:SourceSansPro-Regular; font-weight:400">(${point.custom.amount}%)</span></span></div>`
}

export const mountChartCategories = (state: ChartState) => {
    const { group, batch } = state
    const cat = group[0]

    return batch.map(event => event?.[cat])
}

export const mountChartSeries = (state: ChartState, width: number): any => {
    const { batch, group } = state
    const category = group[0]
    let clampedX = width
    if (width < 500) clampedX = clampedX * 0.6
    else if (width < 800) clampedX = clampedX * 0.7
    else clampedX = clampedX * 0.8
    const baseSeriesObj = createBaseSeriesObj(clampedX)

    return batch.reduce((series, currentEvent, index) => {
        return [
            ...series,
            {
                ...baseSeriesObj,
                data: [
                    {
                        ...baseSeriesObj.data[0],
                        y: index,
                        custom: {
                            legendTitle: currentEvent.legendTitle,
                            label: currentEvent.label,
                            amount: Number(currentEvent.value.toFixed(0)),
                            cat: currentEvent?.[category]
                        },
                        partialFill: {
                            fill: currentEvent.fill,
                            amount: Number((currentEvent.value / 100).toFixed(2))
                        }
                    }
                ]
            }
        ]
    }, [])
}
